<template lang="pug">
.tiers-container.pointer(v-if="show" @click="close")
  .tiers-container-content.relative(@click.stop="")
    .times-icon.pointer(@click="close")
    .tiers-title
      span Talla 
      span.uppercase {{ size }}
    p.tiers-summary
      strong {{ unitCount }}
      |  {{ unitsLabel }}
      |  en 
      strong {{ levelCount }}
      |  {{ levelsLabel }}

    shTierList(
      :tiers="tiers"
      :nameProduct="product.product"
      :size="size"
      :brand="product.brand"
      :enable="enableForSize"
      embedded
      @deleted="deleteTier"
      @added="addTier"
      @enable="enableTier"
    )
</template>

<script>
import shTierList from '@/components/elements/TierList'
import { groupTiers } from '@/helpers/tier'

export default {
  name: 'Tiers',
  components: { shTierList },

  props: {
    show: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      required: true
    }
  },

  computed: {
    indexSize () {
      return this.product.sizes.findIndex(size => size === this.size)
    },
    tiers () {
      if (this.indexSize === -1) return []
      return this.product.tiers[this.indexSize]
    },
    enableForSize () {
      return this.product.showLast[this.indexSize] || false
    },
    unitCount () {
      return this.tiers.length
    },
    levelCount () {
      return groupTiers(this.tiers).length
    },
    unitsLabel () {
      return this.unitCount === 1 ? 'unidad' : 'unidades'
    },
    levelsLabel () {
      return this.levelCount === 1 ? 'nivel' : 'niveles'
    }
  },

  methods: {
    close () {
      this.$emit('close')
    },

    deleteTier (group) {
      this.product.tiers[this.indexSize].splice(group.indices[0], 1)
      this.$emit('updateTiers', {
        action: 'delete',
        indexSize: this.indexSize
      })
    },

    addTier (group) {
      this.product.tiers[this.indexSize].push(group.tier)
      this.$emit('updateTiers', {
        action: 'add',
        indexSize: this.indexSize,
        tier: group.tier
      })
    },

    enableTier (enable) {
      this.$set(this.product.showLast, this.indexSize, enable)
    }
  }
}
</script>

<style lang="stylus" scoped>
.tiers-container
  position fixed
  top 0
  left 0
  width 100vw
  height 100vh
  background-color rgba(0, 0, 0, 0.5)
  z-index 12000
  display flex
  justify-content center
  align-items center

.tiers-container-content
  background-color var(--background-principal)
  padding 3em 4rem
  border-radius 1em
  width 100%
  max-width 50rem
  max-height 100%
  cursor default
  overflow-y auto

.tiers-title
  font-size 1.2em
  font-weight 600
  margin-bottom .35em
  text-align left

.tiers-summary
  margin 0 0 2em
  font-size 1em
  font-weight normal
  color rgba(0, 0, 0, .65)
  text-align left

  strong
    font-weight 600
    color rgba(0, 0, 0, .85)

.times-icon
  position absolute
  top 1rem
  right 1.5rem
  cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/pages/product/Tiers.vue